import './index.scss'

const BrandLoader = () => {
  return (
    <div className="brand-loader" aria-hidden="true">
      <span className="brand-loader__name">Septi Rizky</span>
    </div>
  )
}

export default BrandLoader
